"use client";

import Link from "next/link";

interface BlogLink {
  title: string;
  slug: string;
}

// Map landing page contexts to relevant blog posts
const BLOG_LINKS: Record<string, BlogLink[]> = {
  "cellular-shades": [
    { title: "Cellular Shades vs Roller Shades: Which Is Best?", slug: "cellular-shades-vs-roller-shades" },
    { title: "Energy Efficient Window Treatments Guide", slug: "energy-efficient-window-treatments" },
    { title: "Best Blinds for Insulation & Energy Savings", slug: "best-blinds-for-insulation" },
  ],
  "roller-shades": [
    { title: "Cellular Shades vs Roller Shades: Which Is Best?", slug: "cellular-shades-vs-roller-shades" },
    { title: "How to Install Blinds: Step-by-Step Guide", slug: "how-to-install-blinds" },
    { title: "How Much Do Blinds Cost? Complete Pricing Guide", slug: "how-much-do-blinds-cost" },
  ],
  "custom-blinds": [
    { title: "Custom vs Ready-Made Blinds: What to Know", slug: "custom-vs-ready-made-blinds" },
    { title: "How to Measure for Blinds: Complete Guide", slug: "how-to-measure-for-blinds" },
    { title: "How Much Do Blinds Cost? Complete Pricing Guide", slug: "how-much-do-blinds-cost" },
  ],
  "plantation-shutters": [
    { title: "Blinds vs Shades vs Shutters: Complete Comparison", slug: "blinds-vs-shades-vs-shutters" },
    { title: "How Much Do Blinds & Shutters Cost?", slug: "how-much-do-blinds-cost" },
    { title: "Window Treatment Installation Cost Guide", slug: "window-treatment-installation-cost" },
  ],
  "bedroom-blinds": [
    { title: "Best Blinds for Bedrooms: Complete Guide", slug: "best-blinds-for-bedroom" },
    { title: "Home Theater Blackout Guide", slug: "home-theater-blinds" },
    { title: "Noise Reducing Window Treatments", slug: "noise-reducing-blinds" },
  ],
  "bathroom-blinds": [
    { title: "Best Blinds for Bathrooms: Moisture & Privacy", slug: "best-blinds-for-bathrooms" },
    { title: "Blinds vs Curtains: Which Is Better?", slug: "blinds-vs-curtains" },
    { title: "How to Choose the Right Blinds", slug: "blinds-vs-shades-vs-shutters" },
  ],
  "kitchen-blinds": [
    { title: "Best Blinds for Kitchens: Heat & Moisture Guide", slug: "best-blinds-for-kitchen" },
    { title: "Faux Wood vs Real Wood Blinds", slug: "faux-wood-vs-real-wood-blinds" },
    { title: "How to Clean & Maintain Blinds", slug: "how-to-fix-blinds" },
  ],
  "living-room-blinds": [
    { title: "Blinds vs Curtains: Which Is Better?", slug: "blinds-vs-curtains" },
    { title: "Window Treatment Trends 2026", slug: "window-treatment-trends-2026" },
    { title: "Inside Mount vs Outside Mount Guide", slug: "inside-mount-vs-outside-mount" },
  ],
  "faux-wood-blinds": [
    { title: "Faux Wood vs Real Wood Blinds Comparison", slug: "faux-wood-vs-real-wood-blinds" },
    { title: "Best Blinds for Bathrooms", slug: "best-blinds-for-bathrooms" },
    { title: "How Much Do Blinds Cost?", slug: "how-much-do-blinds-cost" },
  ],
  "energy-efficient-blinds": [
    { title: "Energy Efficient Window Treatments Guide", slug: "energy-efficient-window-treatments" },
    { title: "Best Blinds for Insulation", slug: "best-blinds-for-insulation" },
  ],
  "child-safe-blinds": [
    { title: "Pet-Friendly Window Treatments", slug: "pet-friendly-blinds" },
    { title: "Best Blinds for Nursery Rooms", slug: "best-blinds-for-nursery" },
    { title: "Cordless Blinds Guide", slug: "smart-blinds-guide" },
  ],
  "cheap-custom-blinds": [
    { title: "How Much Do Blinds Cost? Complete Guide", slug: "how-much-do-blinds-cost" },
    { title: "Custom vs Ready-Made Blinds", slug: "custom-vs-ready-made-blinds" },
    { title: "Window Treatment Installation Cost Guide", slug: "window-treatment-installation-cost" },
  ],
  default: [
    { title: "How to Measure for Blinds: Complete Guide", slug: "how-to-measure-for-blinds" },
    { title: "Blinds vs Shades vs Shutters: Comparison", slug: "blinds-vs-shades-vs-shutters" },
    { title: "How Much Do Blinds Cost?", slug: "how-much-do-blinds-cost" },
  ],
};

export default function RelatedBlogPosts({ context }: { context?: string }) {
  const links = BLOG_LINKS[context || ""] || BLOG_LINKS.default;

  return (
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">From Our Blog</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {links.map((link) => (
            <Link
              key={link.slug}
              href={`/blog/${link.slug}`}
              className="bg-white rounded-lg p-5 shadow-sm hover:shadow-md transition-shadow group"
            >
              <h3 className="font-semibold text-gray-900 group-hover:text-primary-600 transition-colors text-sm leading-snug">
                {link.title}
              </h3>
              <span className="text-primary-600 text-xs mt-2 inline-block font-medium">
                Read more &rarr;
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
